// Utility.js

import { createApiPathWithQueryStrings } from "../../api/fetch/fetchServices";
import * as apiConstants from '../../constants/apiConstants';
import { ESTABLISHMENT_301_REQUIRED_ENUMERATION } from "../../constants/EstablishmentStatusEnumeration";

export function cleanInputData(inputString) {
  const lines = inputString.split('\n');
  for (let i = 0; i < lines.length; i++) {
    let line = lines[i].trim();
    let cleanedLine = '';
    for (let j = 0; j < line.length; j++) {
      const character = line[j];
      try {
        btoa(character);
        cleanedLine += character;
      } catch (error) {
        console.error(`Error encoding Line ${i + 1}, Character ${j + 1} (${character}): ${error.message}`);
      }
    }
    lines[i] = cleanedLine;
  }

  return lines.join('\n');
}

export function calculateHiredDateFromService(serviceMonths) {
    const currentDate = new Date();

    // Calculate the year and month based on the length of service
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth();

    year -= Math.floor(serviceMonths / 12);
    month -= serviceMonths % 12;

    // Adjust the year and month if the result is negative
    if (month < 0) {
      year -= 1;
      month += 12;
    }

    // Assuming hired date is on the first day of the calculated month
    const hiredDate = new Date(year, month, 1);

    return hiredDate;
}

export function is301Required(establishment, includeLegacySize = false) {
  // DESTRUCTURE ESTABLISHMENT
  const naics_code = establishment.naics.naics_code;
  const size = establishment.size;
  const state = establishment.address.state.toUpperCase();
  const establishment_type = establishment.establishment_type;

  // SIZE VALUES
  const sizeEnumeration = {
    SIZE_250_PLUS: 3,
    SIZE_100_249: 22,
    SIZE_20_249: 2,
    SIZE_20_99: 21,
    SIZE_1_19: 1,
  };

  // STATE PLAN VALUES
  const establishmentEnumeration = {
    STATE_GOVERNMENT: 2,
    LOCAL_GOVERNMENT: 3,
  };

  // GET STATE PLAN TRUE/FALSE
  let managed_by_state_plan = false;
  const excludedStatesData = window.getExcludedStatesData();
  if (excludedStatesData['fully_excluded_states'].includes(state)) {
    managed_by_state_plan = true;
  } else if (
    excludedStatesData['partially_excluded_states'].includes(state) &&
    (establishment_type === establishmentEnumeration.STATE_GOVERNMENT ||
      establishment_type === establishmentEnumeration.LOCAL_GOVERNMENT)
  ) {
    managed_by_state_plan = true;
  }

  return new Promise((resolve, reject) => {

    // IF MANAGED BY STATE PLAN, RETURN STATE PLAN VALUE
    if (managed_by_state_plan) {
      resolve(ESTABLISHMENT_301_REQUIRED_ENUMERATION.STATE_PLAN);
      return;
    }

    // IF SIZE 1 | 2, RETURN NOT REQUIRED
    if ((size === sizeEnumeration.SIZE_1_19 || size === sizeEnumeration.SIZE_20_99) || includeLegacySize) {
      if (includeLegacySize && size === sizeEnumeration.SIZE_20_249) {
        resolve(ESTABLISHMENT_301_REQUIRED_ENUMERATION.LEGACY)
      } else {
        resolve(ESTABLISHMENT_301_REQUIRED_ENUMERATION.NOT_REQUIRED);
      }

      return;
    }

    // LOCAL STORAGE VALUE FOR NAICS CODE
    const cachedValue = localStorage.getItem(`required_301_${naics_code}`);

    // API PATH FOR 300_301Required
    const queryParams = { naics: naics_code };
    const eligibilityCheckPath = createApiPathWithQueryStrings(
      apiConstants.caseDataFormRequired,
      queryParams
    );

    // IF LOCAL STORAGE EXISTS CHECK ITS VALUE AND RETURN REQUIRED | NOT REQUIRED
    if (cachedValue !== null) {
      cachedValue === "true" ? resolve(ESTABLISHMENT_301_REQUIRED_ENUMERATION.REQUIRED) : resolve(ESTABLISHMENT_301_REQUIRED_ENUMERATION.NOT_REQUIRED);
    } else {
      // IF LOCAL STORAGE DOES NOT EXIST, MAKE API CALL
      fetch(eligibilityCheckPath)
        .then(response => response.json())
        .then(data => {
          const required_301 = data['300and301_required_301'];
          // CREATE NEW LOCAL STORAGE ITEM FOR NAICS CODE
          localStorage.setItem(`required_301_${naics_code}`, required_301);
          if (required_301) {
            resolve(ESTABLISHMENT_301_REQUIRED_ENUMERATION.REQUIRED);
          } else {
            resolve(ESTABLISHMENT_301_REQUIRED_ENUMERATION.NOT_REQUIRED);
          }
        })
        .catch(error => {
          console.error('Error fetching data:', error);
          reject(error);
        });
    }
  });
}




/** WEBPACK FOOTER **
 ** ./src/components/common/Utility.js
 **/